/**
 * API amounts are integer cents. UI uses decimal dollars.
 */

export function centsToDollarAmount(cents) {
  return Number(cents || 0) / 100;
}

/** Display cents as localized currency (e.g. $12.34). */
export function formatCentsAsCurrency(cents, currency = 'CAD') {
  const amount = centsToDollarAmount(cents);
  try {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${currency} ${amount.toFixed(2)}`;
  }
}

/**
 * Parse user-entered dollars ($, commas, spaces allowed) → integer cents.
 * Returns NaN if empty or invalid.
 */
export function dollarsStringToCents(value) {
  const s = String(value ?? '')
    .trim()
    .replace(/[$,\s]/g, '')
    .replace(/^\+/, '');
  if (s === '' || s === '-' || s === '.' || s === '-.') return NaN;
  const n = Number(s);
  if (Number.isNaN(n) || !Number.isFinite(n)) return NaN;
  return Math.round(n * 100);
}

/** Prefill a dollar input from API cents (fixed 2 decimals). */
export function centsToDollarInputString(cents) {
  if (cents == null || cents === '') return '';
  const c = Number(cents);
  if (Number.isNaN(c)) return '';
  return (c / 100).toFixed(2);
}
